import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { setTokens, clearToken } from "@/lib/api";

const AuthContext = createContext(null);

export const homeFor = (role) =>
  ({
    customer: "/app",
    business_owner: "/business",
    business_manager: "/business",
    cashier: "/staff",
    admin: "/admin",
  }[role] || "/login");

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading, false = anon
  const bootstrap = useCallback(async () => {
    const token = localStorage.getItem("onekite_token");
    if (!token) return setUser(false);
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      clearToken();
      setUser(false);
    }
  }, []);

  useEffect(() => {
    bootstrap();
  }, [bootstrap]);

  const applyAuth = (data) => {
    setTokens(data);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {
      /* best-effort — token may already be expired */
    }
    clearToken();
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, applyAuth, logout, refresh: bootstrap }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
